export default "__VITE_ASSET__caa09333__"